import { useSelector } from 'react-redux';
import { useGetDataQuery } from 'common/commonRedux/getRTKApi/baseApi';
import type { CollaborationStatus } from 'modules/ProjectManagement/Collaboration/types';

/**
 * Shared collaboration status for the current organisation. `isClient` is a
 * non-partner org; `isAccepted` means a live collaboration exists for it.
 */
export default function useCollaborationStatus(skip = false) {
  const userType = useSelector((state: any) => state.auth?.profileData?.tokenData?.userType);
  // The endpoint only serves Admin and Supervisor JWTs.
  const allowed = userType === 'Administrator' || userType === 'Supervisor';
  const { data, isLoading, refetch } = useGetDataQuery(
    { urlObjKey: 'CollaborationStatus', params: {} },
    { skip: skip || !allowed, refetchOnMountOrArgChange: true }
  );
  const status: CollaborationStatus | undefined = data && typeof data === 'object' && 'state' in data ? data : undefined;
  const isPartnerOrg = !!status?.isPartnerOrg;
  const isAccepted = status?.state === 'Accepted';
  return {
    status,
    isLoading,
    refetch,
    isAdmin: userType === 'Administrator',
    isPartnerOrg,
    isClient: !!status && !isPartnerOrg,
    isAccepted,
    partnerOrgName: status?.partnerOrgName || '',
    canShowCollaborationTab:
      !!status && (status.sharedProjectCount > 0 || status.state === 'Accepted' || status.isPartnerOrg),
  };
}
